// @ts-check
import React from 'react';
import cx from 'classnames';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';
import Icon from 'shared/components/Icon';

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('HH:MM');

const RawTimeMaskInput = ({ name, className = '', meta, ...otherInputProps }) => {
  const showError = meta && meta.touched && meta.error;
  return (
    <div className="field">
      <p className="control has-icons-left">
        <MaskedInput
          name={name}
          id={name}
          type="text"
          className={cx('input bulma__input', className, { 'is-danger': showError })}
          placeholder="hh:mm pm"
          mask={[/[0-1]/, /\d/, ':', /[0-5]/, /\d/, ' ', /(a|p)/, 'm']}
          pipe={autoCorrectedDatePipe}
          {...otherInputProps}
        />
        <span className="icon is-small is-left">
          <Icon name="clock" />
        </span>
      </p>
      {showError && <p className="help has-text-left is-danger">{meta.error}</p>}
    </div>
  );
};

RawTimeMaskInput.displayName = 'RawTimeMaskInput';

const TimeMaskInput = connectFormComponentToReduxForm(RawTimeMaskInput);
TimeMaskInput.displayName = 'TimeMaskInput';

export default TimeMaskInput;
